import React, { useEffect, useRef, useState } from "react";
import { Upload, Button, message, Row, Col, Modal, Spin, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { apiRefresh } from "../../../services/api";

const { Option } = Select;
const AddEmployerDocuments = ({
  onAddEmployerDocument,

  onUploadAvatar,
  imageUploadSuccess,

  potentialClientInfo,

  onGetEmployerDocument,
  employerDocumentRes,

  onFilterData,

  handleCancel,
  folderDocType,
  onAddPCDocument,
  addDocInFolder,
}) => {
  const [fileList, setFileList] = useState([]);
  const [previewVisible, SetPreviewVisible] = useState(false);
  const [previewImage, SetPreviewImage] = useState("");
  const [previewTitle, SetPreviewTitle] = useState("");
  const [docTypeValue, SetDocTypeValue] = useState(0);
  const [docTypeId, setdocTypeId] = useState(folderDocType);
  const [loading, setLoading] = useState(false);
  const [uploadResults, setUploadResults] = useState([]);
  const [docUpload, setDocUploaded] = useState(false);
  const uploadingNamesRef = useRef(new Set());
  const shownMessagesRef = useRef(new Set());

  useEffect(() => {
    if (addDocInFolder && folderDocType != -1 && folderDocType != 0) {
      SetDocTypeValue(folderDocType);
    }
  }, [folderDocType]);

  const onHandleChange = ({ fileList }) => {
    if (
      fileList &&
      fileList[fileList.length - 1] &&
      fileList[fileList.length - 1].size > 50 * 1024 * 1024
    ) {
      message.warning("File size should not be greater than 50MB");
    } else setFileList(fileList);
  };

  const onHandleChangeUpload = async ({ fileList: updatedFileList }) => {
    const MAX_FILE_SIZE = 40 * 1024 * 1024; // 40MB
    const MAX_TOTAL_FILES = 10;

    const allowedExtensions = new Set([
      ".doc",
      ".docx",
      ".pdf",
      ".xlsx",
      ".XLSX",
      ".csv",
      ".zip",
      ".xlsm",
      ".txt",
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".bmp",
      ".tiff",
      ".mp3",
      ".mp4",
      ".heic",
      ".m4a",
    ]);

    const getFileExtension = (filename) =>
      filename.slice(filename.lastIndexOf(".")).toLowerCase();

    const existingFileNames = new Set(fileList.map((f) => f.name));
    const processingSet = uploadingNamesRef.current;
    const shownMessages = shownMessagesRef.current;
    const newValidFiles = [];

    // Limit total files
    const totalAllowed = MAX_TOTAL_FILES - fileList.length;
    let count = 0;

    for (const file of updatedFileList) {
      if (count >= totalAllowed) {
        if (!shownMessages.has("max-limit")) {
          shownMessages.add("max-limit");
          message.warning(`You can upload up to ${MAX_TOTAL_FILES} files.`, 6);
        }
        break;
      }

      const ext = getFileExtension(file.name);
      const msgKey = `${file.name}-${file.size}`;

      if (existingFileNames.has(file.name) || processingSet.has(file.name))
        continue;

      if (!allowedExtensions.has(ext)) {
        if (!shownMessages.has(msgKey)) {
          shownMessages.add(msgKey);
          message.warning(`Unsupported file type: ${file.name}`, 7);
        }
        continue;
      }

      if (file.size <= 0) {
        if (!shownMessages.has(msgKey)) {
          shownMessages.add(msgKey);
          message.warning(`The file "${file.name}" is corrupt (0KB).`, 7);
        }
        continue;
      }

      if (file.size > MAX_FILE_SIZE) {
        if (!shownMessages.has(msgKey)) {
          shownMessages.add(msgKey);
          message.warning(`File "${file.name}" exceeds 40MB limit.`, 7);
        }
        continue;
      }

      newValidFiles.push(file);
      processingSet.add(file.name);
      count++;
    }

    if (newValidFiles.length === 0) return;

    setFileList((prev) => [...prev, ...newValidFiles]);
    setLoading(true);

    const responses = await Promise.allSettled(
      newValidFiles.map(async (file) => {
        try {
          const formData = new FormData();
          formData.append("files", file.originFileObj || file);
          formData.append("BranchId", localStorage.getItem("selectedBranchId"));

          const response = await onAddPCDocument(formData);

          const fileData = response?.payload?.find(
            (item) => item.fileName === file.name
          );

          return {
            success: true,
            name: file.name,
            clientId: potentialClientInfo.id,
            fileURL: fileData?.httpUrl,
          };
        } catch (error) {
          const failKey = `fail-${file.name}`;
          if (!shownMessages.has(failKey)) {
            shownMessages.add(failKey);
            message.error(`Upload failed: ${file.name}`, 6);
          }
          setFileList((prev) => prev.filter((f) => f.name !== file.name));
          return { success: false, name: file.name, error };
        } finally {
          processingSet.delete(file.name);
        }
      })
    );

    const successful = responses
      .filter((r) => r.status === "fulfilled" && r.value.success)
      .map((r) => r.value);

    setUploadResults((prev) => [...prev, ...successful]);

    setLoading(false);
    if (successful.length > 0) {
      setDocUploaded(true);
    }
  };

  const handleSubmit = () => {
    let clientprofileid = potentialClientInfo.id;
    let count = 0;
    if (fileList.length > 10) {
      message.error("10 files at a time can be uploaded.");
    } else if (fileList && fileList.length > 0) {
      for (var i = 0; i < fileList.length; i++) {
        let selectedFile = fileList[i].originFileObj;
        let extensionArr = selectedFile.name.split(".");
        let fileExt = extensionArr[extensionArr.length - 1];
        if (
          fileExt == "mp3" ||
          fileExt == "mp4" ||
          fileExt == "avi" ||
          fileExt == "mov" ||
          fileExt == "wmv"
        ) {
          message.error(fileExt + " type is not allowed");
        } else {
          setLoading(true);
          let formData = new FormData();
          formData.append("file", selectedFile);

          const JsonData = {
            SubjectId: clientprofileid,
            FamilyId: "00000000-0000-0000-0000-000000000000",
            DocumentTypeId: parseInt(docTypeValue ?? "0"),
            Title: selectedFile && selectedFile.name,
            SizeInKB: selectedFile && selectedFile.size,
            DocuementExtension: selectedFile && selectedFile.type,
            IsAgent: false,
            IsClient: false,
            ShowAgent: false,
            ShowClient: false,
            QuestionnaireId: 0,
            BranchId: localStorage.getItem("selectedBranchId"),
          };
          formData.append("Data", JSON.stringify(JsonData));
          onAddEmployerDocument(formData)
            .then(() => {
              count++;
              if (fileList.length == count) {
                var data = new Object();
                data.id = clientprofileid;
                data.docType = folderDocType;
                data.CaseId = 0;
                data.IsVisa = false;
                onGetEmployerDocument(data);
                setLoading(false);
                handleCancel();
                message.success("Successfully Added!");
              }
            })
            .catch(() => setLoading(false));
        }
      }
    }
  };

  const handleSubmitDoc = () => {
    let clientprofileid = potentialClientInfo.id;

    if (fileList && fileList.length > 0) {
      setLoading(true);
      let data = {
        documentTypeId:
          docTypeValue == 0
            ? addDocInFolder && folderDocType !== -1
              ? folderDocType
              : 0
            : docTypeValue,
        documents: uploadResults,
      };
      const addClientDocOpt = {
        url: `v1/document/SaveDocumentWithData`,
      };
      addClientDocOpt.types = [
        "ADD_CLIENT_DOCUMENT_SUCCESS",
        "ADD_CLIENT_DOCUMENT_FAILURE",
      ];

      apiRefresh
        .post(addClientDocOpt, data)
        .then(() => {
          var data = new Object();
          data.id = clientprofileid;
          data.docType = folderDocType;
          data.CaseId = 0;
          data.IsVisa = false;
          onGetEmployerDocument(data);
          setLoading(false);
          handleCancel();
          message.success("Successfully Added!");
        })
        .catch(() => setLoading(false));
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    SetPreviewVisible(true);
    SetPreviewImage(file.url || file.preview);

    SetPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const removeFileBeforeUpload = (file) => {
    if (uploadResults.length == 1) {
      setDocUploaded(false);
    }
    setFileList((prev) => prev.filter((f) => f.name !== file.name));
    setUploadResults((prev) => prev.filter((f) => f.name !== file.name));
  };

  return (
    <Spin size="large" spinning={loading}>
      <Row>
        <div>
          <Select
            style={{ width: 150, marginBottom: 10 }}
            placeholder="Select"
            allowClear
            defaultValue="Select"
            value={docTypeValue}
            onChange={(value) => SetDocTypeValue(value)}
          >
            <Option value={0}>Select</Option>
            {onFilterData &&
              onFilterData.items &&
              onFilterData.items.map((item, index) => (
                <Option value={item.id}> {item.name}</Option>
              ))}
          </Select>
        </div>
      </Row>
      <Row>
        <Col span={24}>
          <div className="client-doc-main">
            <Upload
              listType="picture-card"
              fileList={fileList}
              beforeUpload={() => false}
              onPreview={handlePreview}
              onChange={onHandleChangeUpload}
              onRemove={(file, fileList) => removeFileBeforeUpload(file)}
              multiple
            >
              {fileList && fileList.length < 10 ? (
                <div className="import-file-button-sec">
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </div>
                </div>
              ) : null}
            </Upload>
          </div>
          <Button
            style={{ marginTop: "10px" }}
            onClick={handleSubmitDoc}
            className="float-right"
            type="primary"
            disabled={!(fileList && fileList[0])}
          >
            Upload
          </Button>

          <Modal
            visible={previewVisible}
            title={previewTitle}
            footer={null}
            onCancel={handleCancel}
          >
            <img alt="example" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </Col>
      </Row>
    </Spin>
  );
};

export default AddEmployerDocuments;
